import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ReactNode } from "react";

interface ThemeProviderProps {
  children: ReactNode;
  /** Set to a theme string to force a specific theme (e.g. "light"). */
  forcedTheme?: string;
  /** Default theme when none is stored. */
  defaultTheme?: string;
}

/**
 * App-wide theme provider wrapping next-themes.
 * Applies `class` strategy so `.dark` toggles CSS variables.
 */
export function ThemeProvider({
  children,
  defaultTheme = "system",
  forcedTheme,
}: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme={defaultTheme}
      enableSystem
      disableTransitionOnChange
      forcedTheme={forcedTheme}
    >
      {children}
    </NextThemesProvider>
  );
}
